module.exports = __webpack_public_path__ + "img/goldregen-2020-083.f6598554.jpg";